// src/pages/BrandManagement/index.tsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

// Components
import BreadCrumb from 'Components/Common/BreadCrumb';
import BrandForm from './components/BrandForm';
import BrandPreview from './components/BrandPreview';

// Redux
import {
  fetchBrandInfo,
  updateBrandInfo,
} from 'slices/brandManagement/thunk';

// Types
import { BrandFormData } from './types';

// Hooks
import { useBrandingTitle } from '../../hooks';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('brand_management');

/**
 * Trang quản lý thương hiệu
 * Cho phép chỉnh sửa logo, tên công ty, tên viết tắt và màu sắc thương hiệu
 */
const BrandManagement: React.FC = () => {
  const dispatch = useDispatch<any>();
  
  // Redux state
  const {
    brandInfo,
    loading,
  } = useSelector((state: any) => state.BrandManagement);

  // Giá trị form đang gõ (chưa lưu) — dùng để panel "Xem trước" bên phải cập nhật ngay theo từng
  // ký tự thay vì đứng yên chờ tới khi lưu thành công (mục UAT-ADM-033).
  const [liveValues, setLiveValues] = useState<BrandFormData | null>(null);

  // Load thông tin thương hiệu khi mount
  useEffect(() => {
    dispatch(fetchBrandInfo());
  }, [dispatch]);

  // Lỗi đã được toast trực tiếp trong handleSave/handleLogoUpload/handleLogoDelete ngay tại nơi
  // catch — KHÔNG toast lại ở đây theo Redux state.error, vì các *.rejected reducer cũng set
  // state.error cho message tương tự, dẫn tới hiển thị 2 toast trùng nội dung cho cùng 1 lỗi
  // (cùng bug đã sửa ở UserManagement/index.tsx và RoleManagement/index.tsx).
  
    useBrandingTitle(st('quan_ly_thuong_hieu_text'));
  
    // Xử lý lưu thay đổi
  const handleSave = async (formData: BrandFormData) => {
    console.log('handleSave called with data:', formData);
    try {
      console.log('Dispatching updateBrandInfo...');
      await dispatch(updateBrandInfo(formData)).unwrap();
      toast.success(st('cap_nhat_thuong_hieu_thanh_cong_message'));
      // BrandManagement.brandInfo cập nhật -> Layout tự đồng bộ sang
      // BrandingConfiguration + cache (xem src/Layouts/index.tsx)
      // Reload brand info
      dispatch(fetchBrandInfo());
    } catch (err: any) {
      console.error('Update error:', err);
      toast.error(err || st('co_loi_xay_ra_khi_cap_message'));
    }
  };
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <BreadCrumb title={st('quan_ly_thuong_hieu_text')} pageTitle={st('cau_hinh_text')} />
          
          <Row>
            {/* Left Column: Form */}
            <Col lg={8}>
              <Card>
                <CardHeader>
                  <div>
                    <h5 className="card-title mb-1">{st('cau_hinh_thuong_hieu_title')}</h5>
                    <p className="text-muted mb-0 small">
                      {st('quan_ly_logo_ten_cong_ty_text')}
                    </p>
                  </div>
                </CardHeader>
                <CardBody>
                  {loading && !brandInfo ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">{st('dang_tai_text')}</span>
                      </div>
                    </div>
                  ) : (
                    <BrandForm
                      initialData={brandInfo}
                      onSave={handleSave}
                      loading={loading}
                      onLiveChange={setLiveValues}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>

                        {/* Right Column: Preview */}
            <Col lg={4}>
              <BrandPreview
                brandInfo={liveValues && brandInfo ? { ...brandInfo, ...liveValues } : brandInfo}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BrandManagement;